var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 28,
    viewBox: "0 0 34 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.6663 3.99984C33.6663 2.1665 32.1663 0.666504 30.333 0.666504H3.66634C1.83301 0.666504 0.333008 2.1665 0.333008 3.99984V23.9998C0.333008 25.8332 1.83301 27.3332 3.66634 27.3332H30.333C32.1663 27.3332 33.6663 25.8332 33.6663 23.9998V3.99984ZM30.333 3.99984L16.9997 12.3332L3.66634 3.99984H30.333ZM30.333 23.9998H3.66634V7.33317L16.9997 15.6665L30.333 7.33317V23.9998Z",
    fill: "#196B69"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.758279e2b2d9d6a378bcd462ff1706ba.svg";
export { ForwardRef as ReactComponent };